import { Button, Col, Divider, Row, Select, Spin, message } from "antd";
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { useState } from 'react';
import { useDespathClientsByMonthAndYear } from "../../../../hooks/orders/useDespathCientsByMonthAndYear.hook";
import { Accordion, AccordionSummary, AccordionDetails, IconButton, Box, Modal } from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { pdfDepartureListByClientDateEvent } from "../../../../_events/order_list_view/find.event";
import { Link } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
import { APP_ROUTES, MAIN_ROUTES } from "../../../../_config/routes";
import { useDownloadExcelDespathClientsDate } from "../../../../hooks/orders/useDownloadExcelDepatchClientsDate.hook";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '80%',
    bgcolor: 'background.paper',
    border: '2px solid #fff',
    borderRadius: '20px',
    boxShadow: 24,
    p: 4,
};

const months = [
    { value: '1', label: 'Enero' },
    { value: '2', label: 'Febrero' },
    { value: '3', label: 'Marzo' },
    { value: '4', label: 'Abril'},
    { value: '5', label: 'Mayo'},
    { value: '6', label: 'Junio'},
    { value: '7', label: 'Julio'},
    { value: '8', label: 'Agosto'},
    { value: '9', label: 'Septiembre'},
    { value: '10', label: 'Octubre'},
    { value: '11', label: 'Noviembre'},
    { value: '12', label: 'Diciembre'},
]

const years = Array.from({ length: new Date().getFullYear()- 2022 }).map( (_, index) => ({ value: 2023 + index, label: `${2023 + index}` }));

export function InfoDeparturesClients(){

    const [openPDF, setOpenPDF] = useState(false);
    const [pdf, setPDF] = useState(null);

    const hook = useDespathClientsByMonthAndYear();
    const excelHook = useDownloadExcelDespathClientsDate();

    const handleClosePDF = () => {
        setOpenPDF(false);
        setPDF(null);
    };

    const displayPDF = (client, date) => {
        if(! client) message.error('No hay Cliente');
        else if(! date) message.error('No hay Fecha');
        else {
            pdfDepartureListByClientDateEvent(client, date)
            .then(data => {
                setPDF(data.data.bytes);
                setOpenPDF(true);     
            })
            .catch(err => {
                message.error(err.message);
            });
        }    
    }

    return(
        <Row>
            <Col lg={20} xs={24}>
                <Select 
                    value={months.find( m => m.value === hook.month.toString() )}
                    onChange={(e) => {
                        hook.setMonth(e);
                    }}
                    options={months}
                />
                <Select
                    value={years.find( m => m.value === hook.year )}
                    onChange={(e) => {
                        hook.setYear(e);
                    }}
                    options={years}
                />
            </Col>
            <Col lg={4} xs={24}>
                {
                    excelHook.loading ? 
                    <Spin />
                    :
                    <Button
                        type="primary"
                        onClick={() => {
                            excelHook.downloadExcel(hook.month, hook.year);
                        }}
                    >
                        Descargar Excel
                    </Button>
                }
            </Col>
            <Col>
            <Divider />
            </Col>
            <Col lg={24} xs={24}>
                {
                    hook.data.map((og, key) => {
                        return(
                            <Accordion key={`departure_date_${key}`}>
                                <AccordionSummary
                                style={{ backgroundColor: '#ddd' }}
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls={`panel${key + 1}-content`}
                                id={`panel${key + 1}-header`}
                                >
                                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                                        <div style={{ display: 'flex', flexDirection: 'row', height: '100%', alignItems: 'center', marginRight: '20px' }}><strong>{og.date}</strong></div>                                        
                                    </div>
                                </AccordionSummary>
                                <AccordionDetails>
                                    {
                                        og.orders.map((o, key) => {
                                            return(
                                                <div key={`div_client_name_${key}`}>
                                                    <div style={{ display: 'flex', flexDirection: 'row', height: '100%' }}>
                                                        <IconButton
                                                            color='primary'
                                                            aria-label='pdf'
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                displayPDF(o.uuid, og.date);
                                                            }}
                                                        >
                                                            <PictureAsPdfIcon />
                                                        </IconButton>
                                                        <Link to={`${MAIN_ROUTES.app_modules}${APP_ROUTES.despatch_client_date}?date=${og.date}&client=${o.uuid}`}>
                                                            <IconButton
                                                                color='primary'
                                                            >
                                                                <SearchIcon />
                                                            </IconButton>
                                                        </Link>                                                        
                                                        <span style={{ height: '35px', display: 'flex', flexDirection: 'row', alignItems: 'center', alignContent: 'center', justifyContent: 'center' }}>
                                                        {o.name}
                                                        </span>
                                                    </div>
                                                    <div style={{ width: '100%', background: '#ddd', height: '1px' }}></div>
                                                </div>
                                            );
                                        })
                                    }
                                </AccordionDetails>
                            </Accordion>
                        );
                    })
                }
            </Col>
            <Modal
                open={openPDF}
                onClose={handleClosePDF}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Row>
                    {
                    !pdf ? <>Cargando...</> :
                    <Col xs={24} lg={24}>
                        <object width="100%" height="600px" 
                        data={`data:application/pdf;base64,${pdf}`} 
                        type="application/pdf" className="internal"
                        >
                        <embed 
                            src={`data:application/pdf;base64,${pdf}`}
                            type="application/pdf"
                        />
                        </object>
                    </Col>
                    }
                    </Row>
                </Box>
            </Modal>  
        </Row>
    );
}